module.exports = __webpack_public_path__ + "static/cover-d99ded1aa3f37725e49c27ae4a14a90d.png";